<template>
        <v-card class="elevation-10">
            <v-card-title>
                <CreateModal v-on:created="getApplications()"></CreateModal>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="applications.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs">{{ props.item.name }}</td>
                    <td class="layout px-0">
                        <v-speed-dial
                                v-model="fab[props.index]"
                                :top="top"
                                :bottom="bottom"
                                :right="right"
                                :left="left"
                                :direction="direction"
                                :open-on-hover="hover"
                                :transition="transition"
                        >
                            <v-btn
                                    slot="activator"
                                    v-model="fab[props.index]"
                                    color="primary"
                                    dark
                                    fab
                                    flat
                            >
                                <v-icon>settings</v-icon>
                                <v-icon>close</v-icon>
                            </v-btn>
                            <EditModal :status="props.item" v-on:created="getApplications()"></EditModal>
                            <v-btn
                                    fab
                                    dark
                                    small
                                    color="red"
                                    @click="deleteItem(props.item.id)"
                            >
                                <v-icon color="white">delete</v-icon>
                            </v-btn>
                        </v-speed-dial>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="applications.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
            </div>
        </v-card>
</template>

<script>
    import CreateModal from './components/CreateModal';
    import EditModal from './components/EditModal';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                applications: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getApplications();
            this.debouncedGetApplications = _.debounce(this.getApplications, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetApplications();
            },
            last_page: function () {
                if (this.page > this.applications.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Type of projects.'
                });
            },
            setPage (page) {
                this.page = page;
                this.getApplications();
            },
            getApplications () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page
                    }
                };
                this.$store.dispatch('getProjectSamples', params).then((res) => {

                    this.applications = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteProjectSampleOrder', {
                            id: id
                        }).then((res) => {

                            this.getApplications();

                        }).catch((error) => {

                        });
                    }
                })
            },
        },
        components : {
            CreateModal,
            EditModal
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/config/projects/samples/ProjectSampleComponent.vue